<template>
  <div class="dashboard__list__header">
    <div class="checkbox__cell">
      <slot name="checkbox"></slot>
    </div>
    <div class="lqi__cell header-cell" v-responsive.sm.xl.lg.md v-if="showInEnv([env_tentacles, env_flower])">
      <div v-tooltip.top="$t('dashboard.nav.lqi_hover')">{{ $t('dashboard.nav.lqi') }}</div>
      <OrderSelector column="lqi" :active="activeSort" @onChange="sortChange" />
    </div>
    <div class="sa__cell header-cell" v-responsive.sm.xl.lg.md>
      <div>SA</div>
      <OrderSelector column="sa" :active="activeSort" @onChange="sortChange" />
    </div>
    <div class="unit__cell header-cell" :class="unitClassSwitch">
      <div>{{ $t('dashboard.nav.unit') }}</div>
      <OrderSelector column="unit" :active="activeSort" @onChange="sortChange" />
    </div>
<!--      <div class="order__cell header-cell" v-responsive.sm.xs.md>-->
<!--          <div>{{ $t('dashboard.nav.favourite') }}</div>-->
<!--      </div>-->
    <div class="customer__cell header-cell" v-if="user.is_dealer">
      <div>{{ $t('dashboard.nav.customer') }}</div>
      <OrderSelector column="customer" :active="activeSort" @onChange="sortChange" />
    </div>
    <div class="remark__cell header-cell" v-responsive.sm.xl.lg.md>
      <div>{{ $t('dashboard.nav.remark') }}</div>
      <OrderSelector column="remark" :active="activeSort" @onChange="sortChange" />
    </div>
    <div :class="dynamicClassSwitch" v-responsive.xl v-if="showInEnv([env_tentacles, env_flower])">
      <div v-for="sensor in sensors" :key="sensor.id" class="sensor__cell header-cell">
        <div>{{ $t('metrics.' + sensor.label) }}</div>
        <OrderSelector :column="sensor.label" :active="activeSort" @onChange="sortChange" />
      </div>
    </div>
    <div class="last-update__cell header-cell" v-responsive.xl.lg.md>
      <div>{{ $t('dashboard.nav.l_update') }}</div>
      <OrderSelector column="last-update" :active="activeSort" @onChange="sortChange" />
    </div>
    <div class="event__cell header-cell" v-responsive.xl.lg.md v-if="showInEnv([env_tentacles, env_flower])">
      <div>{{ $t('dashboard.nav.last_event') }}</div>
      <!--<OrderSelector column="settings-sent" :active="activeSort" @onChange="sortChange" />-->
    </div>
    <div class="dynamic-timing__cell header-cell" v-if="showTimSen" v-responsive.xl.lg>
      <div>{{ $t('dashboard.nav.timing') }}</div>
    </div>
    <div class="order__cell header-cell" v-if="showInEnv([env_tentacles, env_flower]) && !user.is_dealer">
      <div>{{ $t('dashboard.nav.favourite') }}</div>
    </div>
    <div :class="actionClassSwitch"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderSelector from '@/components/OrderSelector.vue';

export default {
  name: 'DashboardListHeader',
  components: {
    OrderSelector,
  },
  data() {
    return {
      showTimSen: false,
      SOIL_3XS: 1,
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
      env_flower: process.env.VUE_APP_ENV_FLOWER,
    };
  },
  props: {
    activeSort: {
      type: Object,
    },
    sensors: {
      type: Array,
      default: value => [1],
    },
  },
  computed: {
    ...mapGetters('tentacle', ['user', 'type']),
      unitClassSwitch() {
        return this.sensors.length === 7 ? "unit__cell__xtm header-cell" : "unit__cell header-cell";
      },
      actionClassSwitch() {
          return this.sensors.length === 7 ? "action__cell__xtm header-cell" : "action__cell header-cell";
      },
      dynamicClassSwitch() {
          return this.sensors.length === 7 ? "dynamic-section-xtm" : "dynamic-section";
      }
  },
  methods: {
    sortChange(sort) {
      this.$emit('onSortChange', sort);
    },
    showInEnv(type) {
      if (Array.isArray(type)) {
        return type.includes(process.env.VUE_APP_ENVIRONMENT);
      }
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-cell {
  display: flex;
  align-items: center;
  color: $grey;
  font-size: 1.3rem;
  font-weight: 500;
}

.dashboard__list__header {
  height: 6rem;
  display: flex;
  align-items: stretch;
  border-bottom: 0.1rem solid $border-color;
}

.dynamic-section {
  width: 95rem;
  flex-grow: 1;
  display: flex;
  align-items: stretch;
}

.dynamic-section-xtm {
  width: 108rem;
  flex-grow: 1;
  display: flex;
  align-items: stretch;
}

.checkbox__cell {
  width: 5rem;
  display: flex;
  align-items: center;
  padding-left: 1rem;
}

.unit__cell {
  width: 23rem;
}

.unit__cell__xtm {
  width: 22.5rem;
}

.remark__cell {
  width: 14rem;
}

.remark__cell__xtm {
  width: 15rem;
}

.lqi__cell {
  width: 6.1rem;
  margin-left: -0.7rem;
  word-break: break-word;
}

.customer__cell {
  width: 11rem;
  word-break: break-word;
}
.customer__cell__xtm {
  width: 12rem;
  word-break: break-word;
}

.sa__cell {
  width: 5rem;
}

.sensor__cell {
  width: 13.2rem;
  flex: 1;
}

.last-update__cell {
  width: 12rem;
  margin-left: auto;
}

.event__cell {
  width: 11rem;
  margin-left: auto;
}

.dynamic-timing__cell {
  width: 18rem;
  margin-left: auto;
}

.dynamic-sensing__cell {
  width: 20rem;
  margin-left: auto;
}

.notification__cell {
  width: 10rem;
  margin-left: auto;
}

.order__cell {
  width: 7rem;
  margin-left: 0.5rem;
    @media only screen and (max-width: 991px) {
        padding-left: 1em;
        width: 7.5em;
        margin-left: 0;
    }
}

.action__cell {
  width: 12rem;
  margin-left: auto;
}

.action__cell__xtm {
  width: 12rem;
  margin-left: auto;
}

.help__paragraph {
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.5rem;

  span {
    color: $company-color;
  }
}
</style>
